(function () {
    'use strict';
    var m = angular.module('common');
    m.factory('fileMetaInfoBuildHelper', function () {
        return function () {
            var helpers = {
                sharefile_file: function (data, options, entityData, advanced) {
                    var fields = [
                        'create_time',
                        'size',
                        'actor_id',
                        'is_external'
                    ];
                    var conditional_fields = [
                        'is_deleted',
                        'is_quarantined',
                        'is_vaulted'
                    ];
                    var pairs = _(data).reduce(function (memo, dataEl) {
                        if (fields.includes(dataEl.key) && dataEl.value || conditional_fields.includes(dataEl.key) && dataEl.value === true) {
                            var itemClass = {};
                            itemClass['info-field-' + dataEl.key] = true;
                            var value = dataEl.value;
                            if (dataEl.key === 'size') {
                                value = value + ' Kilobytes';
                            } else if (dataEl.key === 'create_time') {
                                value = moment.utc(value).local().format('YYYY-MM-DD HH:mm:ss');
                            }
                            memo.push({
                                class: itemClass,
                                key: entityData[dataEl.key].label,
                                value: value
                            });
                        }
                        return memo;
                    }, []);
                    return pairs;
                }
            };
            return helpers;
        };
    });
}());